import Panel from '../components/panel'
import {Button} from '../components/button'
import PropertyInput from "../components/inputs/input-property.tsx";

import { useStore } from "../state/state.ts";
import { round_to_1000 } from "../functions.ts";
import { useContext, useEffect } from "react";
import ModalConfirmButton from '../components/modal_close_button.tsx';
import { ConfigContext } from '../config_context.ts';

export default function ModalHeizungFuture() {
    const foerderung = useContext(ConfigContext).foerderung;
    const pop_modal = useStore((state)=>state.pop_modal);
    const close_menu = useStore((state) => state.close_menu);
    const api_recalculate = useStore((state) => state.api_recalculate);
    const init_property_if_undefined = useStore((state) => state.init_property_if_undefined);
    const financial_plan_dummy = useStore((state)=>state.financial_plan_dummy);

    const heizung_future = useStore((state)=>state.heizung_future);    
    //console.log(heizung_future);
    const api_get_costs = useStore((state)=>state.api_get_costs);
    const privat =  useStore((state)=>state.get_property("privat"));
    
    useEffect(()=>{
        api_get_costs("heating_system",heizung_future);
    },[heizung_future]);

  let percent = (heizung_future == "heating_system_current_4") ? "35%" : "30%";
  return (<Panel >
            <h1 id="modal-title">Welche neue Heizung ist geplant?</h1>            
            <PropertyInput type="heizung_future"/>
            
            { foerderung && (heizung_future == "heating_system_planned_7") && 
               <PropertyInput type="hot_water"/>
            }

            <PropertyInput type="heizung_kosten" placeholder_prefix={"optional ca."} placeholder_override={round_to_1000(financial_plan_dummy["heating_system"].total_costs)  + " €"}/>

            { foerderung && 
              (heizung_future != undefined) &&
              (heizung_future != "heating_system_planned_0") && 
              (heizung_future != "heating_system_planned_8") && 
              (heizung_future != "heating_system_planned_9") &&
               <p><b>Die mögliche Heizungsförderung von {percent} kann durch Boni auf bis zu maximal 70% gesteigert werden.</b></p>
            }

            {  foerderung && (heizung_future == "heating_system_planned_7") &&
               <PropertyInput type="heizung_dust_emission"/>
            }

            {  foerderung && ((heizung_future == "heating_system_planned_2") || 
               (heizung_future == "heating_system_planned_3") ||
               (heizung_future == "heating_system_planned_4") ||
               (heizung_future == "heating_system_planned_10")) && 
               <PropertyInput type="heizung_natural_refrigerant_future"/>
            }

            {  foerderung && ((heizung_future !== undefined) &&
               (heizung_future !== "heating_system_planned_0") &&
               (heizung_future !== "heating_system_planned_8") &&
               (heizung_future !== "heating_system_planned_9")) && 
               <>
                  <PropertyInput type={"privat"}/>
                  {privat && <PropertyInput type="heizung_wird_ausgetauscht"/>}
                  {privat &&<PropertyInput type="income_gt_4k"/>}
               </>
            }
            
            <br></br>
            { foerderung && <p>*Insgesamt ist die Förderung auf 70% gedeckelt.</p>}
            
            <PropertyInput placeholder_prefix="z.B." type="energie_kosten_planned"/>
            
           <ModalConfirmButton  onClick={()=>{
                close_menu();
                init_property_if_undefined("heizung_future");
                api_recalculate();
                pop_modal();
            }}/>
         </Panel>)
}

